export default "__VITE_ASSET__DMK$sRlB__"